import { type ReactNode, useRef } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

type ConfirmationModalProps = {
    isOpen: boolean;
    onSubmit: () => void;
    closeModal: () => void;
    isLoading?: boolean;
    title: string;
    children: ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
};

export const ConfirmationModal = ({
    isOpen,
    onSubmit,
    closeModal,
    confirmButtonText,
    cancelButtonText,
    isLoading,
    title,
    children
}: ConfirmationModalProps) => {
    const initialFocus = useRef<HTMLButtonElement>(null);
    const { t } = useTranslation('commons');

    return (
        <Modal open={isOpen} onDismiss={closeModal} initialFocus={initialFocus} className="!z-100">
            <Modal.Body>
                <Modal.Title>{title}</Modal.Title>
                <Modal.Content className="pt-m text-center font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {children}
                </Modal.Content>
                <Modal.Footer
                    className="flex flex-col items-center justify-between space-y-3 pb-12 pt-8 xs:flex-row xs:space-x-3 xs:space-y-0"
                    divider={false}>
                    <Button
                        variant="secondary"
                        className="w-full"
                        ref={initialFocus}
                        onClick={closeModal}
                        disabled={isLoading}>
                        {cancelButtonText || t('no')}
                    </Button>
                    <Button onClick={onSubmit} className="w-full" isLoading={isLoading}>
                        {confirmButtonText || t('yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmationModal;
